import { START_DOWNLOAD, END_DOWNLOAD, DOWNLOAD_PROGRESS, SET_SELECTED_DOCUMENT_IDS, RESET_SELECTED_DOCUMENT_IDS } from "../types"

export const startDownloadAction = (id) => ({
	type: START_DOWNLOAD,
	payload: id,
})

export const startBulkDownloadAction = (id) => ({
	type: START_DOWNLOAD,
	payload: id,
})

export const endDownloadAction = (id) => ({
	type: END_DOWNLOAD,
	payload: id,
})

export const endBulkDownloadAction = (id) => ({
	type: END_DOWNLOAD,
	payload: id,
})

export const downloadProgressAction = (id, percentage) => ({
	type: DOWNLOAD_PROGRESS,
	payload: { id: id, percentage: percentage },
})

export const bulkDownloadProgressAction = (id, percentage) => ({
	type: DOWNLOAD_PROGRESS,
	payload: { id: id, percentage: percentage },
})

export const setSelectedIdsAction = (id) => ({
	type: SET_SELECTED_DOCUMENT_IDS,
	payload: id,
})

export const resetSelectedIdsAction = () => ({
	type: RESET_SELECTED_DOCUMENT_IDS,
})
